import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { GetUser } from "../../../utils/AuthUtils";
import { addConfiguration } from "../../../redux/features/grid-configuration/gridConfigurationSlice";
import { connect } from "react-redux";
import { gridConfigurationAPI } from "../../../api/grid-configuration/gridConfigurationAPI";
import GridCard from "../../components/grid-card/GridCard";
import { pagesLinks } from "../../../utils/PageUtils";
import moment from "moment"
import { dateValueFormatter } from "../../../utils/GridUtils";

export const RelatedOrdersGridContainer = ({
  lightVersion,
  data,
  title,
  linkTo,
  isModal,
  gridId,
  gridConfigurationList,
  addConfiguration,
  hideBreadcrumbs,
  isFetching,
  isSO
}) => {
  const [columns, setColumns] = useState();
  const [showModalReset, setShowModalReset] = useState(false);
  const [columnapi, setColumnapi] = useState();
  const [eventapi, setEventapi] = useState();
  const [groupColWidth, setGroupColWidth] = useState(220);
  const [currentDensity, setCurrentDensity] = useState();

  function handleGoToPage(event) {
    // console.log(event.data)
    // if (event.data != undefined)
    //     history.push(pagesLinks.TODetailPage+"/"+event.data.id);
    if (event.data != undefined && !isSO) {
      const win = window.open(
        pagesLinks.newOrderDetailsPage + "/" + event.data.transportOrderID,
        "_blank"
      );
      // FIXME: this causes an error if the browser prevents pops up from being opened
      win.focus();
    }
    else {
      const win = window.open(
        pagesLinks.newOrderDetailsPage + "/" + event.data.id,
        "_blank"
      );
      // FIXME: this causes an error if the browser prevents pops up from being opened
      win.focus();
    }
  }

  const buildDefaultColumnsGrid = () => {
    if (isSO)
    return [
      {
          headerName: "TMS Order ID",
          field: "tmsOrderId",
          width: 200,
          colId: "tmsOrderId"
      },
      {
          headerName: "TMS Collection ID",
          field: "collectionId",
          width: 210,
          colId: "collectionId"
      },
      {
          headerName: "Customer",
          field: "customer",
          width: 285,
          colId: "customer",
      },
      {
          headerName: "TMS Customer",
          field: "tmsCustomer",
          width: 285,
          colId: "tmsCustomer"
      },
      {
          headerName: "Status",
          field: "status",
          width: 190,
          colId: "status"
      },
      {
          headerName: "Reference 1",
          field: "reference1",
          width: 210,
          colId: "reference1"
      },
      {
          headerName: "Reference 2",
          field: "reference2",
          width: 210,
          colId: "reference2"
      },
      {
          headerName: "Reference 3",
          field: "reference3",
          width: 210,
          colId: "reference3"
      },
      {
          headerName: "Sender (Name)",
          field: "shipperName",
          width: 285,
          colId: "shipperName"
      },
      {
          headerName: "Sender (Postal Code)",
          field: "shipperPostalCode",
          width: 260,
          colId: "shipperPostalCode"
      },
      {
          headerName: "Sender (City)",
          field: "shipperCity",
          width: 210,
          colId: "shipperCity"
      },
      {
          headerName: "Sender (Country)",
          field: "shipperCountry",
          width: 235,
          colId: "shipperCountry"
      },
      {
          headerName: "Origin (Name)",
          field: "originName",
          width: 285,
          colId: "originName"
      },
      {
          headerName: "Origin (Postal Code)",
          field: "originPostalCode",
          width: 260,
          colId: "originPostalCode"
      },
      {
          headerName: "Origin (City)",
          field: "originCity",
          width: 210,
          colId: "originCity"
      },
      {
          headerName: "Origin (Province)",
          field: "originProvince",
          width: 235,
          colId: "originProvince"
      },
      {
          headerName: "Origin (Country)",
          field: "originCountry",
          width: 235,
          colId: "originCountry"
      },
      {
          headerName: "Consignee (Name)",
          field: "consigneeName",
          width: 285,
          colId: "consigneeName"
      },
      {
          headerName: "Consignee (Postal Code)",
          field: "consigneePostalCode",
          width: 280,
          colId: "consigneePostalCode"
      },
      {
          headerName: "Consignee (City)",
          field: "consigneeCity",
          width: 220,
          colId: "consigneeCity"
      },
      {
          headerName: "Consignee (Country)",
          field: "consigneeCountry",
          width: 250,
          colId: "consigneeCountry"
      },
      {
          headerName: "Destination (Name)",
          field: "destinationName",
          width: 250,
          colId: "destinationName"
      },
      {
          headerName: "Destination (Postal Code)",
          field: "destinationPostalCode",
          width: 280,
          colId: "destinationPostalCode"
      },
      {
          headerName: "Destination (City)",
          field: "destinationCity",
          width: 220,
          colId: "destinationCity"
      },
      {
          headerName: "Destination (Province)",
          field: "destinationProvince",
          width: 250,
          colId: "destinationProvince"
      },
      {
          headerName: "Destination (Country)",
          field: "destinationCountry",
          width: 250,
          colId: "destinationCountry"
      },
      {
          headerName: "Requested Early Pickup Date",
          field: "requestedEarlyPickUpDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 300,
          valueFormatter: dateValueFormatter,
          colId: "requestedEarlyPickUpDate"
      },
      {
          headerName: "Requested Late Pickup Date",
          field: "requestedLatePickUpDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 300,
          valueFormatter: dateValueFormatter,
          colId: "requestedLatePickUpDate"
      },
      {
          headerName: "Actual Pickup Date",
          field: "actualPickUpDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 240,
          valueFormatter: dateValueFormatter,
          colId: "actualPickUpDate"
      },
      {
          headerName: "Requested Early Delivery Date",
          field: "requestedEarlyDeliveryDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 320,
          valueFormatter: dateValueFormatter,
          colId: "requestedEarlyDeliveryDate"
      },
      {
          headerName: "Requested Late Delivery Date",
          field: "requestedLateDeliveryDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 315,
          valueFormatter: dateValueFormatter,
          colId: "requestedLateDeliveryDate"
      },
      {
          headerName: "Actual Delivery Date",
          field: "actualDeliveryDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 250,
          valueFormatter: dateValueFormatter,
          colId: "actualDeliveryDate"
      },
      {
          headerName: "Gross Weight",
          field: "grossWeight",
          width: 210,
          colId: "grossWeight"
      },
      {
          headerName: "Volume",
          field: "volume",
          width: 170,
          colId: "volume"
      },
      {
          headerName: "Loading Meters",
          field: "loadingMeters",
          width: 220,
          colId: "loadingMeters"
      },
      {
          headerName: "Total Ship Unit Count",
          field: "totaleShipUnitCount",
          width: 260,
          colId: "totaleShipUnitCount"
      },
      {
          headerName: "First Trip",
          field: "firstTrip",
          width: 190,
          colId: "firstTrip"
      },
      {
          headerName: "Last Trip",
          field: "lastTrip",
          width: 190,
          colId: "lastTrip"
      },
      {
          headerName: "Last Leg Type",
          field: "lastTripType",
          width: 220,
          colId: "lastTripType"
      },
      {
          headerName: "Owner Branch",
          field: "ownerBranch",
          width: 210,
          colId: "ownerBranch"
      },
      {
          headerName: "Lane",
          field: "lane",
          width: 210,
          colId: "lane"
      },
      {
          headerName: "Customer Main Order Reference",
          field: "customerMainOrderReference",
          width: 285,
          colId: "customerMainOrderReference"
      },
      {
          headerName: "TMS Order Insert User",
          field: "tmsOrderInsertUser",
          width: 250,
          colId: "tmsOrderInsertUser"
      },
      {
          headerName: "TMS Order Insert Date",
          field: "tmsOrderInsertDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 250,
          valueFormatter: dateValueFormatter,
          colId: "tmsOrderInsertDate"
      },
      {
          headerName: "TMS Collection Insert User",
          field: "tmsCollectionInsertUser",
          width: 250,
          colId: "tmsCollectionInsertUser"
      },
      {
          headerName: "TMS Collection Insert Date",
          field: "tmsCollectionInsertDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          width: 250,
          valueFormatter: dateValueFormatter,
          colId: "tmsCollectionInsertDate"
      },
      {
          headerName: "Requested Asset Type",
          field: "requestedAssetType",
          width: 210,
          colId: "requestedAssetType"
      },
      {
          headerName: "Service Type",
          field: "serviceType",
          width: 210,
          colId: "serviceType"
      },
      {
          headerName: "Booking Service",
          field: "bookingService",
          colId: "bookingService",
          width: 210
      },
      {
          headerName: "Booking Result",
          field: "bookingResult",
          colId: "bookingResult",
          width: 210
      },
      {
          headerName: "Booking Date",
          field: "bookingDate",
          cellRenderer: (data) => {
              return data.value != ' ' ? moment(data.value).format('DD/MM/YYYY HH:mm') : ""
          },
          colId: "bookingDate",
          valueFormatter: dateValueFormatter,
          width: 210
      },
      {
          headerName: "Business Flow Type",
          field: "businessFlowType",
          width: 200,
          colId: "businessFlowType"
      },
      {
          headerName: "Last Leg Status",
          field: "lastLegStatus",
          width: 200,
          colId: "lastLegStatus"
      }
      ,
      {
          headerName: "Legacy Code",
          field: "legacyCode",
          width: 170,
          colId: "legacyCode"
      }
  ];
    else return [
      {
        headerName: "Order Id",
        field: "tmsObjectNumber",
        colId: "tmsObjectNumber",
        width: "166px",
      },
      {
        headerName: "Branch",
        field: "branch",
        colId: "branch",
        width: "135px",
      },
      {
        headerName: "Customer",
        field: "customer",
        colId: "customer",
        width: "269px",
      },
      {
        headerName: "Origin",
        field: "origin",
        colId: "origin",
        width: "253px",
      },
      {
        headerName: "Destination",
        field: "destination",
        colId: "destination",
        width: "261px",
      },
      {
        headerName: "SU Count",
        field: "shipUnitCount",
        colId: "shipUnitCount",
        width: "136px",
      },
      {
        headerName: "Total Volume (M3)",
        field: "totalVolume",
        colId: "totalVolume",
        width: "155px",
      },
      {
        headerName: "G. Weight (KG)",
        field: "grossWeight",
        colId: "grossWeight",
        width: "164px",
      },
      {
        headerName: "Linear M.",
        field: "linearMeters",
        colId: "linearMeters",
        width: "144px",
      },
      {
        headerName: "Last Event",
        field: "lastEvent",
        colId: "lastEvent",
        width: "228px",
      },
      {
        headerName: "Status",
        field: "status",
        colId: "status",
        width: "218px",
      },
    ];
  };

  function myFilterList(myList, colId) {
    var newList = [];

    for (var i = 0; i < myList.length; i++) {
      if (myList[i].colId != colId) newList.push(myList[i]);
    }

    return newList;
  }

  function buildColumnsGridFromConfig(configuration) {
    var defaultCols = buildDefaultColumnsGrid();
    var newConfiguration = [];

    for (var i = 0; i < configuration.length; i++) {
      var j = 0;
      while (j < defaultCols.length) {
        if (configuration[i].colId == defaultCols[j].colId) {
          defaultCols[j].width = configuration[i].width;
          defaultCols[j].hide = configuration[i].hide;
          defaultCols[j].rowGroup = configuration[i].rowGroupIndex != null;
          defaultCols[j].rowGroupIndex = configuration[i].rowGroupIndex;
          newConfiguration.push(defaultCols[j]);
          j = defaultCols.length;
          defaultCols = myFilterList(defaultCols, configuration[i].colId);
        }
        j++;
      }
    }

    if (defaultCols.length > 0) {
       //eslint-disable-next-line
      for (var i = 0; i < defaultCols.length; i++) {
        newConfiguration.push(defaultCols[i]);
      }
    }

    if (configuration[0].colId == "ag-Grid-AutoColumn")
      setGroupColWidth(configuration[0].width);

    if (
      configuration[configuration.length - 1].colId ==
      "ag-Grid-GlobalProperties"
    )
      setCurrentDensity(configuration[configuration.length - 1].rowDensity);

    return newConfiguration;
  }

  function handleCloseModalCancel() {
    setShowModalReset(false);
  }

  function handleCloseModalReset() {
    let defaultCols = buildDefaultColumnsGrid();

    for (var i = 0; i < defaultCols.length; i++) {
      defaultCols[i].hide = false;
      defaultCols[i].rowGroup = false;
      defaultCols[i].rowGroupIndex = null;
    }

    eventapi.applyColumnState({state: defaultCols, applyOrder: true});

    var gridConfigObj = getGridConfigInStore(gridId);

    if (gridConfigObj != null && gridConfigObj.gridConfig != null) {
      // remove da store e db
      var params = {
        gridId: gridId,
        insertUser: GetUser().email,
      };

      gridConfigurationAPI.removeGridConfiguration(params, (res) => {
        addConfiguration({
          gridId: params.gridId,
          gridConfig: null,
        });
      });
    }

    setShowModalReset(false);
  }

  function handleSaveGridConfig(columnState, columnApi, eventApi, density) {
    if (columnState == "reset") {
      setShowModalReset(true);
      setColumnapi(columnApi);
      setEventapi(eventApi);
      setCurrentDensity(density);
    } else {
      var configuration = [];
      var tempGroupColWidth = 220;
      for (var i = 0; i < columnState.length; i++) {
        if (columnState[i].colId != "ag-Grid-AutoColumn") {
          configuration.push({
            colId: columnState[i].colId,
            width: columnState[i].width,
            hide: columnState[i].hide,
            rowGroupIndex: columnState[i].rowGroupIndex,
          });
        } else {
          tempGroupColWidth = columnState[i].width;
        }
      }
      configuration.unshift({
        colId: "ag-Grid-AutoColumn",
        width: tempGroupColWidth,
      });
      configuration.push({
        colId: "ag-Grid-GlobalProperties",
        rowDensity: density,
      });

      setCurrentDensity(density);

      var params = {
        gridId: gridId,
        configuration: JSON.stringify(configuration),
        insertUser: GetUser().email,
      };

      gridConfigurationAPI.addOrUpdateGridConfiguration(params, (res) => {
        addConfiguration({
          gridId: params.gridId,
          gridConfig: configuration,
        });
      });
    }
  }

  function getGridConfigInStore(gridId) {
    for (var i = 0; i < gridConfigurationList.length; i++) {
      if (gridId == gridConfigurationList[i].gridId)
        return gridConfigurationList[i];
    }

    return null;
  }

  function getIsNotDefaultConfig(gridId) {
    var gridConfigObj = getGridConfigInStore(gridId);

    return gridConfigObj != null && gridConfigObj.gridConfig != null;
  }

  useEffect(() => {
    let isMounted = true;

    var gridConfigObj = getGridConfigInStore(gridId);
    if (gridConfigObj != null) {
      let config = gridConfigObj.gridConfig;
      if (config == null) {
        setColumns(buildDefaultColumnsGrid());
      } else {
        setColumns(buildColumnsGridFromConfig(config));
      }
    } else {
      gridConfigurationAPI.getGridConfiguration(
        {
          userMail: GetUser().email,
          gridId: gridId,
        },
        (res) => {
          if (isMounted) {
            if (res.gridId != null) {
              let parsedConfiguration = JSON.parse(res.configuration);
              setColumns(buildColumnsGridFromConfig(parsedConfiguration));
              addConfiguration({
                gridId: gridId,
                gridConfig: parsedConfiguration,
              });
            } else {
              setColumns(buildDefaultColumnsGrid());
              addConfiguration({
                gridId: gridId,
                gridConfig: null,
              });
            }
          }
        }
      );
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {((!data || data.length === 0)&& !isFetching) ? (
        <h4 style={{marginLeft:'3rem', marginTop:'4rem',fontFamily:'Swiss721BT-normal'}}>Currently, no information about related orders execution is available in the system. Once new information is available, they will be shown in the page</h4>
      ) : (
        <>
          <Modal
            show={showModalReset}
            backdrop="static"
            keyboard={false}
            animation={false}
            centered
            className="modal-bookmarks"
          >
            <Modal.Header style={{ padding: "0" }}>
              <div className="modal-title-bookmarks">
                Are you sure to restore the default grid configuration?
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex pt-4" style={{ float: "right" }}>
                <Button
                  className="bookmarks-cancel-button"
                  onClick={handleCloseModalCancel}
                >
                  Cancel
                </Button>
                <Button
                  className="bookmarks-confirm-button"
                  onClick={handleCloseModalReset}
                >
                  Confirm
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <GridCard
            gridId={gridId}
            handleSaveGridConfig={handleSaveGridConfig}
            groupColWidth={groupColWidth}
            isNotDefaultConfig={getIsNotDefaultConfig(gridId)}
            isFetching={isFetching}
            title={title}
            columns={columns}
            data={data}
            count={data.length}
            lightVersion={lightVersion}
            linkTo={linkTo}
            isModal={isModal}
            currentDensity={currentDensity}
            hideBreadcrumbs={hideBreadcrumbs}
            openPageOnRowClick={true}
            handleGoToPage={handleGoToPage}
          />
        </>
      )}
    </>
  );  
};

const mapStateToProps = function(state) {
  return {
    gridConfigurationList: state.gridConfiguration.gridConfigurationList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addConfiguration: (gridConfiguration) => {
      dispatch(addConfiguration(gridConfiguration));
    },
  };
};

export const RelatedOrdersGrid = connect(
  mapStateToProps,
  mapDispatchToProps
)(RelatedOrdersGridContainer);
